import { render, staticRenderFns } from "./Santong.vue?vue&type=template&id=081d3248&scoped=true"
import script from "./Santong.vue?vue&type=script&lang=js"
export * from "./Santong.vue?vue&type=script&lang=js"
import style0 from "./Santong.vue?vue&type=style&index=0&id=081d3248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081d3248",
  null
  
)

export default component.exports